const SELISE_CLUB_EPOCH = Math.floor(new Date("2026-04-20").getTime() / 1000);

export const hot = (reacts: number, date: Date) => {
  const unixSeconds = Math.floor(date.getTime() / 1000);
  const order = Math.log10(Math.max(reacts * 2, 1));
  const seconds = unixSeconds - SELISE_CLUB_EPOCH;
  return Math.round((order + seconds / 90000) * 1000) / 1000;
};
